module.exports = __webpack_public_path__ + "static/media/logo.390d7a31.svg";